/**
 * Centralized job type configuration
 * This ensures consistent mapping between UI and API across the entire app
 */

// Job type definitions with consistent mapping
// Order matches the existing jobTypes array in professions.js
export const JOB_TYPES = [
  {
    id: 0,        // UI index
    apiId: 0,     // API value for job_type parameter
    name: "Locum",
    slug: "locum",
    icon: "locum",
    description: "Short-term or ad hoc roles to fill in for absent staff or cover immediate needs. Can range from single to multiple."
  },
  {
    id: 1,        // UI index
    apiId: 1,     // API value for job_type parameter
    name: "Full-Time",
    slug: "full-time",
    icon: "fulltime",
    description: "Ongoing employment with a healthcare facility, considered permanent or long-term employment."
  },
  {
    id: 2,        // UI index
    apiId: 4,    // API value for job_type parameter (International uses -2 in API)
    name: "International",
    slug: "international",
    icon: "international",
    description: "Job opportunities in countries outside of your current location. Includes positions requiring relocation or remote work across borders."
  },
  {
    id: 3,        // UI index
    apiId: 2,     // API value for job_type parameter (Temporary uses 2 in API)
    name: "Temporary",
    slug: "temporary",
    icon: "fulltime",
    description: "Non-permanent roles with a fixed duration, typically planned in advance. May last for a set period of time with a defined schedule."
  },
  {
    id: 4,        // UI index
    apiId: 3,     // API value for job_type parameter (Contract uses 3 in API)
    name: "Contract",
    slug: "contract",
    icon: "fulltime",
    description: "Fixed-duration roles with a formal agreement outlining start and end dates. Typically arranged in advance with defined responsibilities and set hours."
  }
];

// Helper functions for job type conversions
export const getJobTypeByIndex = (index) => {
  return JOB_TYPES.find(type => type.id === index);
};

export const getJobTypeByApiId = (apiId) => {
  return JOB_TYPES.find(type => type.apiId === apiId);
};

export const convertIndexToApiId = (index) => {
  const jobType = getJobTypeByIndex(index);
  return jobType ? jobType.apiId : 0;
};

export const convertApiIdToIndex = (apiId) => {
  const jobType = getJobTypeByApiId(apiId);
  return jobType ? jobType.id : 0;
};


// Default job type list for components
export const DEFAULT_JOB_TYPE_LIST = JOB_TYPES.map(type => ({
  name: type.name,
  id: type.apiId
}));

// Check if a job type is considered "full-time" (non-locum)
export const isFullTimeJob = (apiType) => {
  const t = parseInt(apiType);
  return [-2, 1, 2, 3].includes(t);
};